/* jshint maxstatements: false */
(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name smb-app.smbContentTypeConfig
	 * @module smb-app
	 * @restrict E
	 *
	 * @description
	 * Displays a form that can be used for creating new content types or editing
	 * existing content types.
	 *
	 * @usage <caption>Create a new content type</caption>
	 *
	 * <smb-content-type-config content-type-group-id="11" />
	 *
	 * @usage <caption>Edit an existing content type</caption>
	 *
	 * <smb-content-type-config content-type-group-id="11" content-type-id="21" />
	 *
	 * @element input
	 * @param {number=} contentTypeGroupId Id of the content type group the content type belongs to
	 * @element input
	 * @param {number=} contentTypeId An optional id of an existing content type. If provided, the form
	 * will be used to edit the content type. If omitted, the form will be used to create a new content type.
	 */

	angular.module('smb-app')
		.directive('smbContentTypeConfig', ContentTypeConfigDirective)
		.controller('smbContentTypeConfigController', [
			'$scope',
			'$q',
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'sbToastService',
			'smbToolbarService',
			'smbSortService',
			'smbStatusConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbContentTypeGroupTagTypesConfigDataStore',
			'smbContentTypeTagTypeConfigDataStore',
			ContentTypeConfigController
		]);

	var templateUrl = require('./contentTypeConfig.template');
	function ContentTypeConfigDirective() {
		return {
			restrict: 'E',
			controller: 'smbContentTypeConfigController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				contentTypeGroupId: '@',
				contentTypeId: '@'
			},
			scope: {}
		};
	}

	function ContentTypeConfigController(
		$scope,
		$q,
		$state,
		gettextCatalog,
		pxProgressService,
		sbToastService,
		smbToolbarService,
		smbSortService,
		smbStatusConfigDataStore,
		smbContentTypeConfigDataStore,
		smbContentTypeGroupTagTypesConfigDataStore,
		smbContentTypeTagTypeConfigDataStore
	) {
		var vm = this;
		vm.isLoading = false;

		// Set toolbar state, including the title, back arrow target state, and hide contextual toolbar and side panel
		var title = vm.contentTypeId ? gettextCatalog.getString('Edit Document Type') : gettextCatalog.getString('Create Document Type');
		smbToolbarService.set(title, 'contentConfig.types', false, false);
		smbToolbarService.backArrowStateParams = { groupId: vm.contentTypeGroupId };

		// Dirty flags for the various types. These are used to determine if
		// an asterisk should be displayed next to a section's label.
		vm.typeIsDirty = false;
		vm.indexTypesAreDirty = false;
		vm.statusIsDirty = false;

		// The different types being edited in this section.
		vm.contentType = null;
		vm.contentTypeIndexes = [];
		vm.contentTypeGroupIndexes = [];

		// Event handlers for the subcomponents
		vm.onSubmit = onSubmit;
		vm.onContentTypeChange = onContentTypeChange;
		vm.onAddIndexType = onAddIndexType;
		vm.onEditIndexType = onEditIndexType;
		vm.onDeleteIndexType = onDeleteIndexType;
		vm.onStatusChange = onStatusChange;
		vm.onSequence = onSequence;

		vm.contentStatus = null;
		vm.todoStatus = null;
		vm.assignedUserId = null;
		vm.assignedDate = null;
		vm.contentStatuses = [];
		vm.todoStatuses = [];
		vm.readOnly = false;

		var sortTagTypeByName = smbSortService.sortObjectByStringProperty('TagTypeName');

		/*** Controller initialization ***/
		(function initConentTypeConfigController() {
			vm.typeIsDirty = false;
			vm.indexTypesAreDirty = false;
			vm.statusIsDirty = false;

			vm.isLoading = true;
			pxProgressService.visible = true;

			smbContentTypeConfigDataStore
				.getContentType(vm.contentTypeGroupId, vm.contentTypeId)
					.then(function() { /* Copy object so we don't mutate the one on the data store. */
						vm.contentType = Object.assign({}, smbContentTypeConfigDataStore.contentType);
					})
					.then(function() { /* Load content type level tag types */
						return smbContentTypeTagTypeConfigDataStore.getTagTypes(vm.contentTypeId);
					})
					.then(function() { /* Copy array and objects in array so we don't mutate the ones on the data store. */
						vm.contentTypeIndexes = smbContentTypeTagTypeConfigDataStore.tagTypes
							.filter(function(tt) {
								return !(tt.TagTypeName.match(/&&_AirBase_.*/));
							})
							.map(function(tt) {
								return Object.assign({}, tt, {
									Constraints: Object.assign({}, tt.Constraints)
								});
							});
					})
					.then(function() {
						if (vm.contentTypeId) {
							vm.contentStatus = smbContentTypeTagTypeConfigDataStore.contentStatus
							.map(function(tt) {
								return Object.assign({}, tt);
							});
							vm.todoStatus = smbContentTypeTagTypeConfigDataStore.todoStatus
							.map(function(tt) {
								return Object.assign({}, tt);
							});
							vm.assignedUserId = smbContentTypeTagTypeConfigDataStore.assignedUserId
							.map(function(tt) {
								return Object.assign({}, tt);
							});
							vm.assignedDate = smbContentTypeTagTypeConfigDataStore.assignedDate
							.map(function(tt) {
								return Object.assign({}, tt);
							});
						}
						return $q.resolve([]);
					})
					.then(function() {
						vm.contentStatuses = [];
						vm.todoStatuses = [];
						if (vm.contentTypeId) {
							if (vm.contentStatus[0]) {
								vm.contentStatuses = (vm.contentStatus[0].Constraints.DataSetValues) ? vm.contentStatus[0].Constraints.DataSetValues : [];
							}
							if (vm.todoStatus[0]) {
								vm.todoStatuses = (vm.todoStatus[0].Constraints.DataSetValues) ? vm.todoStatus[0].Constraints.DataSetValues : [];
							}
							vm.readOnly = (vm.contentStatuses.length + vm.todoStatuses.length) > 0;
						}
					})
					.then(function() { /* Load content type group level tag types */
						return smbContentTypeGroupTagTypesConfigDataStore.getTagTypes(vm.contentTypeGroupId);
					})
					.then(function() { /* Copy objects, filter out those that are already assigned to the content type. */
						vm.contentTypeGroupIndexes = smbContentTypeGroupTagTypesConfigDataStore.tagTypes
							.filter(function(tt) {
								var t = vm.contentTypeIndexes.find(function(i) { return i.TagTypeId === tt.TagTypeId; });
								return t ? false : true;
							})
							.map(function(tt) {
								return Object.assign({}, tt, {
									Constraints: Object.assign({}, tt.Constraints)
								});
							});

						// sort alphabetically by name
						vm.contentTypeGroupIndexes.sort(sortTagTypeByName);
					})
					.finally(function() { /* done */
						vm.isLoading = false;
						pxProgressService.visible = false;
					});
		}());

		function onSubmit() {
			if (vm.contentType && vm.contentType.FolderName && vm.contentType.IconName) {
				vm.isLoading = true;
				pxProgressService.visible = true;

				saveContentType()
					.then(function() {
						vm.contentType = smbContentTypeConfigDataStore.contentType;
						vm.contentTypeId = vm.contentType.FolderId;
						vm.typeIsDirty = false;
					})
					.then(function() {
						return loadStatuses();
					})
					.then(function() { /* Create any new index types on the content type group */
						return createNewIndexTypes();
					})
					.then(function() {
						return addIndexTypes(vm.contentTypeIndexes
						.concat(vm.contentStatus)
						.concat(vm.todoStatus)
						.concat(vm.assignedUserId)
						.concat(vm.assignedDate));
					})
					.then(function() {
						return updateStatuses();
					})
					.then(function() {
						vm.indexTypesAreDirty = false;
						vm.statusIsDirty = false;
						$state.go('contentConfig.types', {groupId: vm.contentTypeGroupId});
						sbToastService.showSimple(vm.contentTypeId ? gettextCatalog.getString('Document type saved!') : gettextCatalog.getString('New document type created!'));
					})
					.catch(function(e) {
						if (e.status === 409) {
							var message = gettextCatalog.getString('{{folderName}} document type already exists', { folderName: vm.contentType.FolderName });
							sbToastService.showSimple(message);
						} else if (typeof e.data === 'string' && e.status !== 500) {
							sbToastService.showSimple(e.data);
						} else {
							sbToastService.showSimple(gettextCatalog.getString('An unknown error has occurred'));
						}
					})
					.finally(function() {
						vm.isLoading = false;
						pxProgressService.visible = false;
					});
			}
		}

		function loadStatuses() {
			return smbContentTypeTagTypeConfigDataStore.getTagTypes(vm.contentTypeId)
			.then(function(response) {
				vm.contentStatus = smbContentTypeTagTypeConfigDataStore.contentStatus;
				vm.todoStatus = smbContentTypeTagTypeConfigDataStore.todoStatus;
				vm.assignedUserId = smbContentTypeTagTypeConfigDataStore.assignedUserId;
				vm.assignedDate = smbContentTypeTagTypeConfigDataStore.assignedDate;
				return response;
			});
		}
		function saveContentType() {
			if (vm.typeIsDirty || vm.contentType.FolderName) {
				return smbContentTypeConfigDataStore.saveContentType(vm.contentTypeGroupId, vm.contentType);
			} else {
				return $q.resolve(vm.contentType);
			}
		}

		function createNewIndexTypes() {
			if (vm.indexTypesAreDirty) {
				var newIndexTypes = vm.contentTypeIndexes.filter(function(i) {
					return !i.hasOwnProperty('TagTypeId');
				});

				return $q.all(
					newIndexTypes.map(function(i) {
						return smbContentTypeGroupTagTypesConfigDataStore.addTagType(vm.contentTypeGroupId, i)
							.then(function(tt) {
								var index = vm.contentTypeIndexes.indexOf(i);
								if (index >= 0) {
									vm.contentTypeIndexes[index] = tt;
								}
								return tt;
							});
					})
				);
			} else {
				return $q.resolve([]);
			}
		}

		function updateStatuses() {
			if (vm.statusIsDirty) {
				vm.contentStatus[0].Constraints.DataSetValues = vm.contentStatuses;
				vm.todoStatus[0].Constraints.DataSetValues = vm.todoStatuses;

				return smbStatusConfigDataStore.saveStatuses(vm.contentTypeId, vm.contentStatus[0], vm.todoStatus[0]);
			}
			else {
				return $q.resolve([]);
			}
		}

		function addIndexTypes(indexTypes) {
			if (vm.indexTypesAreDirty) {
				vm.statusIsDirty = true;
				return smbContentTypeTagTypeConfigDataStore.setTagTypes(vm.contentTypeId, indexTypes);
			} else {
				return $q.resolve(indexTypes);
			}
		}

		function onContentTypeChange(contentType) {
			vm.typeIsDirty = true;
			vm.contentType = contentType;
		}

		function onAddIndexType(item) {
			vm.indexTypesAreDirty = true;
			vm.contentTypeIndexes = vm.contentTypeIndexes.concat(item);
			vm.contentTypeGroupIndexes = vm.contentTypeGroupIndexes.filter(function(i) {
				return i.TagTypeId !== item.TagTypeId;
			});
		}

		function onDeleteIndexType(item) {
			vm.indexTypesAreDirty = true;
			vm.contentTypeIndexes = vm.contentTypeIndexes.filter(function(tt) {
				return tt.TagTypeName !== item.TagTypeName;
			});

			if (item.TagTypeId) {
				// this tag type exists, need to add it back to group tag types
				vm.contentTypeGroupIndexes = vm.contentTypeGroupIndexes.concat([item]);
				vm.contentTypeGroupIndexes.sort(sortTagTypeByName);
			}
		}

		function onStatusChange() {
			vm.statusIsDirty = true;
		}

		function onSequence(index1, index2) {
			if (canSwap(index1, index2, 0, vm.contentTypeIndexes.length - 1)) {
				var tmp = vm.contentTypeIndexes[index1];
				vm.contentTypeIndexes[index1] = vm.contentTypeIndexes[index2];
				vm.contentTypeIndexes[index2] = tmp;
				vm.indexTypesAreDirty = true;
			}
		}

		function canSwap(index1, index2, lowerBound, upperBound) {
			// 1. cannot swap if index1 and index 2 are equal
			// 2. Cannot swap if index 1 or index 2 is below the lower bound
			// 3. cannot swap if index1 or index 2 is above the upper bound
			if (index1 === index2) {
				return false;
			} else if (index1 < lowerBound || index2 < lowerBound) {
				return false;
			} else if (index1 > upperBound || index2 > upperBound) {
				return false;
			} else {
				return true;
			}
		}

		function onEditIndexType(item) {
			vm.indexTypesAreDirty = true;
			vm.contentTypeIndexes = vm.contentTypeIndexes.map(function(x) {
				return x.TagTypeId === item.TagTypeId ? angular.extend({}, x, item) : x;
			});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeConfig/contentTypeConfig.js
// module id = 66
// module chunks = 1